

export const GET_CROSSSELL_START = 'GET_CROSSSELL_START';
export const GET_CROSSSELL_SUCCESS = 'GET_CROSSSELL_SUCCESS';
export const GET_CROSSSELL_FAILURE = 'GET_CROSSSELL_FAILURE';
export const GET_CROSSSELL_RESET = 'GET_CROSSSELL_RESET';

export const GET_CITY_START = 'GET_CITY_START';
export const GET_CITY_SUCCESS = 'GET_CITY_SUCCESS';
export const GET_CITY_FAILURE = 'GET_CITY_FAILURE';
export const GET_CITY_RESET = 'GET_CITY_RESET';

export const EXPORT_CROSS_SELL_REPORT = "EXPORT_CROSS_SELL_REPORT";
export const EXPORT_CROSS_SELL_REPORT_SUCCESS = "EXPORT_CROSS_SELL_REPORT_SUCCESS";
export const EXPORT_CROSS_SELL_REPORT_FAILED = "EXPORT_CROSS_SELL_REPORT_FAILED";
